import React from 'react'
import TopBar from './TopBar/TopBar'
import SideBar from './SideBar/SideBar'

export default function NavBar() {

  return (
    <>
    <TopBar />
    <SideBar /> 
    </>
  )
}
